module.exports = __webpack_public_path__ + "img/acts.c983f6b8.svg";